import { Pipe, PipeTransform } from '@angular/core';
import { ResidentCarStatusEnum } from '@zaoblako/shared/modules/cctv/enums/resident-car-status.enum';

const residentCarStatusColors: Record<ResidentCarStatusEnum, string> = {
  [ResidentCarStatusEnum.DROVE_IN]: '#4247dc',
  [ResidentCarStatusEnum.DROVE_OUT]: '#5e9a3b'
};

@Pipe({
  name: 'residentCarStatusColor',
  standalone: true
})
export class ResidentCarStatusColorPipe implements PipeTransform {
  public transform(status: ResidentCarStatusEnum): string {
    return residentCarStatusColors[status] || '';
  }
}
